//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var id = 1000;
export default {
  data: function data() {
    return {
      indexlist1: [{
        type: '一',
        num: '1'
      }, {
        type: '二',
        num: '2'
      }, {
        type: '三',
        num: '3'
      }],
      indexlist2: [{
        type: '一',
        num: '1'
      }, {
        type: '二',
        num: '2'
      }, {
        type: '三',
        num: '3'
      }],
      indexlist3: [{
        type: '一',
        num: '1'
      }, {
        type: '二',
        num: '2'
      }],
      num1: [{
        name: '第一章',
        lab: '第{{index}}章',
        num: '一'
      }, {
        name: '第一讲',
        lab: '第{{index}}讲',
        num: '一'
      }, {
        name: '第一课',
        lab: '第{{index}}课',
        num: '一'
      }, {
        name: '第一周',
        lab: '第{{index}}周',
        num: '一'
      }, {
        name: '第一单元',
        lab: '第{{index}}单元',
        num: '一'
      }, {
        name: '第一部分',
        lab: '第{{index}}部分',
        num: '一'
      }, {
        name: '模块一',
        lab: '模块{{index}}',
        num: '一'
      }, {
        name: '情景一',
        lab: '情景{{index}}',
        num: '一'
      }, {
        name: '项目一',
        lab: '项目{{index}}',
        num: '一'
      }, {
        name: 'Chapter1',
        lab: 'Chapter{{index}}',
        num: '1'
      }, {
        name: '项目1',
        lab: '项目{{index}} ',
        num: '1'
      }, {
        name: 'Unit1',
        lab: 'Unit{{index}}',
        num: '1'
      }, {
        name: 'Lession1',
        lab: 'Lession{{index}}',
        num: '1'
      }, {
        name: 'Part1',
        lab: 'Part{{index}}',
        num: '1'
      }],
      num2: [{
        name: '第一节',
        lab: '第{{index}}节',
        num: '一'
      }, {
        name: '第1单元',
        lab: '第{{index}}单元',
        num: '1'
      }, {
        name: '第1课',
        lab: '第{{index}}课',
        num: '1'
      }, {
        name: '第1讲',
        lab: '第{{index}}讲',
        num: '1'
      }, {
        name: '第1部分',
        lab: '第{{index}}部分',
        num: '1'
      }, {
        name: '任务1',
        lab: '任务{{index}}',
        num: '1'
      }, {
        name: '项目1',
        lab: '项目{{index}}',
        num: '1'
      }, {
        name: 'Unit1',
        lab: 'Unit{{index}}',
        num: '1'
      }, {
        name: 'Part1',
        lab: 'Part{{index}}',
        num: '1'
      }, {
        name: 'Lession1',
        lab: 'Lession{{index}}',
        num: '1'
      }, {
        name: '1.1',
        lab: '{{x}}.{{index}}',
        num: '1'
      }],
      num3: [{
        name: '第一节',
        lab: '第{{index}}节',
        num: '一'
      }, {
        name: '第1单元',
        lab: '第{{index}}单元',
        num: '1'
      }, {
        name: '第1课',
        lab: '第{{index}}课',
        num: '1'
      }, {
        name: '第1讲',
        lab: '第{{index}}讲',
        num: '1'
      }, {
        name: '第1部分',
        lab: '第{{index}}部分',
        num: '1'
      }, {
        name: '任务1',
        lab: '任务{{index}}',
        num: '1'
      }, {
        name: '项目1',
        lab: '项目{{index}}',
        num: '1'
      }, {
        name: 'Unit1',
        lab: 'Unit{{index}}',
        num: '1'
      }, {
        name: 'Part1',
        lab: 'Part{{index}}',
        num: '1'
      }, {
        name: 'Lession1',
        lab: 'Lession{{index}}',
        num: '1'
      }, {
        name: '知识点1',
        lab: '知识点{{index}}',
        num: '1'
      }, {
        name: '1.1.1',
        lab: '{{x}}.{{y}}.{{index}}',
        num: '1'
      }],
      radio1: '第{{index}}章',
      radioNum1: '一',
      radio2: '第{{index}}节',
      radioNum2: '一',
      radio3: '第{{index}}节',
      radioNum3: '一',
      Part1: '第{{index}}章',
      Part11: '第{{index}}节',
      Unit1: '第{{index}}节',
      LevelData: [],
      CourseName: ''
    };
  },
  props: {
    courseId: {
      type: String,
      default: ''
    },
    saveConfige: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    saveConfige: function saveConfige(val) {
      if (val == true) {
        this.saveRadioChange();
      }
    }
  },
  created: function created() {
    this.getCatalogConfig(this.courseId);
    this.getCourseName();
  },
  methods: {
    getCatalogConfig: function getCatalogConfig(courseId) {
      var self = this;
      this.$http.post('/api/XOrg/BookMaterial/getCoursewareCatalogConfig', {
        courseId: courseId
      }).then(function (res) {
        if (res.code > 0) {
          self.LevelData = res.levelData;
          self.Part1 = res.levelData.Level1Format;
          self.radioNum1 = res.levelData.Level1Num;
          self.Part11 = res.levelData.Level2Format;
          self.radioNum2 = res.levelData.Level2Num;
          self.Unit1 = res.levelData.Level3Format;
          self.radioNum3 = res.levelData.Level3Num;
          self.radio1 = res.levelData.Level1Format;
          self.radio2 = res.levelData.Level2Format;
          self.radio3 = res.levelData.Level3Format;
        }
      });
    },
    getCourseName: function getCourseName() {
      var self = this;
      this.$http.post('/api/XOrg/BookMaterial/getCourseName', {
        courseId: this.courseId
      }).then(function (res) {
        if (res.code > 0) {
          self.CourseName = res.courseName;
        }
      });
    },
    saveRadioChange: function saveRadioChange() {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/addOrEditCatalog', {
        courseId: this.courseId,
        Level1Format: this.radio1,
        Level1Num: this.radioNum1,
        Level2Format: this.radio2,
        Level2Num: this.radioNum2,
        Level3Format: this.radio3,
        Level3Num: this.radioNum3
      }).then(function (res) {
        if (res.code > 0) {
          self.$message.success(res.msg);
          self.$emit("sendClose");
        } else {
          self.$message.warning(res.msg);
        }

        self.saveConfige = false;
      });
    },
    radio1_change: function radio1_change(name, num) {
      this.Part1 = this.radio1;
      this.radioNum1 = num;
    },
    radio2_change: function radio2_change(name, num) {
      this.Part11 = this.radio2;
      this.radioNum2 = num;
    },
    radio3_change: function radio3_change(name, num) {
      this.Unit1 = this.radio3;
      this.radioNum3 = num;
    }
  }
};